import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';

export default function ElevationsNav(props) {
  let currentSide;
  let backPath = props.slug ? props.slug : '';
  let forwardPath = props.slug ? props.slug : '';

  switch (props.prefix) {
    case 'n':
      backPath = '/west';
      currentSide = 'North Side';
      forwardPath = '/east';
      break;
    case 'e':
      backPath = '/north';
      currentSide = 'East Side';
      forwardPath = '/south';
      break;
    case 's':
      backPath = '/east';
      currentSide = 'South Side';
      forwardPath = '/west';
      break;
    case 'w':
      backPath = '/west';
      currentSide = 'West Side';
      forwardPath = '/north';
      break;
    default:
      console.log('Prefix missing');
  }

  const Button = (props) => {
    return (
      <Link
        to={props.path}
        className="btn btn-dark py-1 px-0"
        style={{ borderRadius: '50%', width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <FontAwesomeIcon icon={props.icon} />
      </Link>
    );
  };

  return (
    <div className="d-flex justify-content-between align-items-center">
      <Button path={backPath} icon={faChevronLeft} />

      <p className="h4 px-2 mb-0">{currentSide}</p>

      <Button path={forwardPath} icon={faChevronRight} />
    </div>
  );
}
